"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiUser = /** @class */ (function (_super) {
    __extends(ApiUser, _super);
    function ApiUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.USER_LIST = "/api/user/list";
        _this.USER_DETAIL = "/api/user/detail";
        _this.USER_COIN_EDIT = "/api/user/update/coin";
        _this.USER_INFO_DELETE = "/api/user/out";
        _this.USER_READING_LIST = "/api/user/comic";
        _this.USER_DECREASED_LIST = "/api/user/coinMinus";
        _this.USER_INCREASED_LIST = "/api/user/coinPlus";
        _this.USER_MEMBERSHIP_HISTORY = "/api/user/userMembershipHistory";
        _this.USER_PAYMENT_LIST = "/api/user/paymentList";
        _this.USER_GIFTBOX_LIST = "/api/user/goodsTicket";
        _this.USER_BONUSCOIN_LIST = "/api/user/bonusCoin";
        _this.USER_BONUSCOIN_CANCEL = "/api/user/cancelBonusCoin";
        _this.USER_CASH_BACK_EVENT_LIST = "/api/event/getCashbackCoin";
        _this.USER_HASH_PROMOTION_LIST = "/api/event/getUserHashPromotion";
        _this.USER_GROUP_HISTORY = "/api/user/userGroupHistory";
        _this.USER_BLOCK_CONNECT_LIST = "/api/user/blockRelationUserId";
        _this.USER_PASS_ACTIVE_LIST = "/api/user/userPassActiveList";
        _this.USER_HASH_RELATED_LIST = "/api/user/userHashRelatedList";
        _this.USER_PAYMENT_CANCEL = "/api/payment/cancel";
        _this.USER_RESERVE_COIN = "/api/user/reserveCoin";
        /**
         * theme 리스트 정렬 api
         * @accessToken
         * @themeId  : 정렬 대상 테마 ID
         * @groupIds : 정렬 순서 별 그룹 ID
         */
        _this.getUserList = function (accesstoken, searchParams) {
            var data = __assign({}, searchParams);
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.USER_LIST,
                data: data,
            });
            return config;
        };
        _this.getUserDetail = function (accesstoken, idx) {
            var data = {
                idx: idx,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.USER_DETAIL,
                data: data,
            });
            return config;
        };
        _this.deleteUserAccount = function (accesstoken, userId, userIp) {
            var data = {
                userIp: userIp,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.USER_INFO_DELETE, "/").concat(userId),
                data: data,
            });
            return config;
        };
        // UserTabApi 통합
        _this.getUserTabApi = function (tabName, accesstoken, userId, request) {
            var data = __assign({ userId: userId }, request);
            var API = function () {
                switch (tabName) {
                    case "membership":
                        return _this.USER_MEMBERSHIP_HISTORY;
                    case "payment":
                        return _this.USER_PAYMENT_LIST;
                    case "coin_decrease":
                        return _this.USER_DECREASED_LIST;
                    case "coin_increase":
                        return _this.USER_INCREASED_LIST;
                    case "bonus_coin":
                        return _this.USER_BONUSCOIN_LIST;
                    case "reading":
                        return _this.USER_READING_LIST;
                    case "gift":
                        return _this.USER_GIFTBOX_LIST;
                    case "cash_back_event":
                        return _this.USER_CASH_BACK_EVENT_LIST;
                    case "hash_event":
                        return _this.USER_HASH_PROMOTION_LIST;
                    case "group_move":
                        return _this.USER_GROUP_HISTORY;
                    case "block_user":
                        return _this.USER_BLOCK_CONNECT_LIST;
                    case "user_pass_active_list":
                        return _this.USER_PASS_ACTIVE_LIST;
                    case "user_hash_related_list":
                        return _this.USER_HASH_RELATED_LIST;
                    default:
                        return "";
                }
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: API(),
                data: data,
            });
            return config;
        };
        _this.calcelBonusCoinitem = function (accesstoken, userId, reserveId) {
            var data = {
                userId: userId,
                reserveId: reserveId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.USER_BONUSCOIN_CANCEL,
                data: data,
            });
            return config;
        };
        _this.calcelPayment = function (accesstoken, userId, pg, orderId) {
            var data = {
                userId: userId,
                pg: pg,
                orderId: orderId,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.USER_PAYMENT_CANCEL,
                data: data,
            });
            return config;
        };
        _this.reserveCoin = function (accesstoken, userId, coins, reason, language) {
            var data = {
                userId: userId,
                coins: coins,
                reason: reason,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken, language: language },
                method: "post",
                url: _this.USER_RESERVE_COIN,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiUser.getInstance = function (initValue) {
        if (!ApiUser.classInstance) {
            this.classInstance = new ApiUser(initValue);
        }
        return this.classInstance;
    };
    return ApiUser;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiUser;
